import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TModalMode } from 'shared/model/types/modalMode.type';

import { CalendarType, TaskBoardSchema } from './types/taskBoardSchema';

const initialState: TaskBoardSchema = {
    calendarType: 'month',
    modalMode: null,
};

export const taskBoardSlice = createSlice({
    name: 'taskBoard',
    initialState,
    reducers: {
        onModalMode: (state: TaskBoardSchema, action: PayloadAction<TModalMode | null>) => {
            state.modalMode = action.payload;
        },
        changeCalendarType: (state: TaskBoardSchema, action: PayloadAction<CalendarType>) => {
            state.calendarType = action.payload;
        },
    },
});

export const { actions: taskBoardActions } = taskBoardSlice;
export const { reducer: taskBoardReducer } = taskBoardSlice;
